// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2EXbS","field":"styles_field__1sY-x","fieldCol":"styles_fieldCol__2HpeL","diffCol":"styles_diffCol__1gVQ-","diff":"styles_diff__rpfhm"};